// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"7b6dd1f6","77":"b9bfb2e4","500":"7a3df194","515":"2e66bf34","630":"dc83b206","827":"797ab545","839":"9520b1b1","912":"1f9e7efa","942":"9e79f043"}[chunkId] + ".chunk.js";
};